export default function Footer() {
  return (
    <footer style={{ padding: '40px 80px', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--black)', flexWrap: 'wrap', gap: '16px' }}>
      <div style={{ fontSize: '11px', letterSpacing: '0.1em', color: 'rgba(245,240,232,0.3)' }}>
        © 2026 Vimal Raj. All rights reserved.
      </div>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '20px', fontWeight: 300, color: '#c9a96e', letterSpacing: '0.08em' }}>
        VR.
      </div>
      <div style={{ fontSize: '11px', letterSpacing: '0.1em', color: 'rgba(245,240,232,0.3)' }}>
        Web App Developer · Digital Solutions
      </div>

      <style>{`
        @media (max-width: 900px) {
          footer { padding: 32px 24px !important; justify-content: center; text-align: center; }
        }
      `}</style>
    </footer>
  );
}
